import {useMutation, useQuery} from '@tanstack/react-query';

import {
  categorizationSecurityGroupView,
  categorizationTagTreeView,
  categorizationFolderTreeView,
  categorizationSearchTreeView,
  categorizationAssignmentTreeView,
  categorizationRunProview,
  getProjectNotificationStatus,
  postCategorizationProview,
  getGoToDocList,
} from '../../api/endpoints/categorizationApi';
import {
  CategorizationGoToDocListParams,
  CategorizationProjectNotificationStatus,
  CategorizationProviewParams,
  CategorizationViewResultsProps,
  DestinationPath,
} from '../../api/types/categorization.type';
import {getConfigKeyValue} from '../../api/endpoints/projectApi';

export const useCategorization = () => {
  // Security Group View
  const securityGroupView = useMutation({
    mutationFn: (payload: any) => categorizationSecurityGroupView(payload),
  });

  // Tag Tree View
  const tagTreeView = useMutation({
    mutationFn: (payload: any) => categorizationTagTreeView(payload),
  });

  // Folder Tree View
  const folderTreeView = useMutation({
    mutationFn: (payload: any) => categorizationFolderTreeView(payload),
  });

  // Search Tree View (no payload)
  const searchTreeView = useMutation({
    mutationFn: () => categorizationSearchTreeView(),
  });

  //Assignment Tree View
  const assignmentTreeView = useMutation({
    mutationFn: (payload: any) => categorizationAssignmentTreeView(payload),
  });

  return {
    securityGroupView,
    tagTreeView,
    folderTreeView,
    searchTreeView,
    assignmentTreeView,
  };
};

export const useCategorizationRunProview = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) =>
  useMutation({
    mutationFn: (payload: CategorizationViewResultsProps) =>
      categorizationRunProview(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

export const useCategorizationProjectNotificationStatus = (
  payload: CategorizationProjectNotificationStatus
) => {
  return useQuery<any, Error, any>({
    queryKey: ['GetProjectNotificationStatus', payload],
    queryFn: () => getProjectNotificationStatus(payload),
    enabled: !!payload.notificationId,
  });
};

export const useCategorizationViewProview = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) =>
  useMutation({
    mutationFn: (payload: CategorizationProviewParams) =>
      postCategorizationProview(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

export const useGoToDocList = (payload: CategorizationGoToDocListParams) => {
  return useQuery<any, Error, any>({
    queryKey: ['GetGoToDocList', payload],
    queryFn: () => getGoToDocList(payload),
    enabled: !!payload.ProviewId,
  });
};

export const useConfigKeyValue = (payload: DestinationPath) => {
  return useQuery<any, Error, any>({
    queryKey: ['GetConfigKeyValue', payload],
    queryFn: () => getConfigKeyValue(payload),
    enabled: false,
  });
};
